document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.ttdc-shop-categories__toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));

      const sublistId = toggle.getAttribute('aria-controls');
      const sublist = document.getElementById(sublistId);
      if (sublist) {
        sublist.classList.toggle('is-open', !expanded);
      }
    });
  });
});